import RestApiModel from "@/api/Model/RestApiModel";

class CompanyType extends RestApiModel {
  static getResourceEndpoint() {
    return '/company-types';
  }
}

export default CompanyType;
